export default {
  dadosIniciais: {
    form: {
      dadosIniciais_nomeCompleto: '',
      dadosIniciais_dataNascimento: '',
      dadosIniciais_cpf: '',
      dadosIniciais_telefoneCelular: '',
      dadosIniciais_ddiTelefoneCelular: '55',
      dadosIniciais_email: '',
      dadosIniciais_nomeSocial:''
    },
    dadosIniciais_idDDDpais: null,
  },
  declaracoesEspecificas: {
    form: {
      declaracoesEspecificasObrigatorias_faixaRendaMensal: '',
      declaracoesEspecificasObrigatorias_faixaPatrimonio: ''
    },
  },
  documentosAnexos: {
    documentos_documentoIdentificacaoFrente: {
      value: "",
      base64: "",
      fileType: null,
      IdDocumentoArquivo: '',
      asyncLoading: false,
      file: null,
      active: false,
      documents: []
    },
    documentos_documentoIdentificacaoVerso: {
      value: "",
      base64: "",
      fileType: null,
      IdDocumentoArquivo: '',
      asyncLoading: false,
      file: null,
      active: false,
      documents: []
    },
    documentos_comprovanteResidenciaComprovante: {
      value: "",
      base64: "",
      fileType: null,
      IdDocumentoArquivo: '',
      asyncLoading: false,
      file: null,
      active: false,
      documents: []
    },
  },
};